import { createContext, useContext } from 'react';
import { FetchPendingPhotoVerificationUseCase } from '../../application/use-cases/FetchPendingPhotoVerificationUseCase';
import { ApiPendingPhotoVerificationRepository } from '../repositories/ApiPendingPhotoVerificationRepository';
import { useHttpClientIntegration } from '@/shared/infra/http/HttpClientContext';

interface PendingPhotoVerificationDIContextType {
  pendingPhotoVerificationUseCase: FetchPendingPhotoVerificationUseCase;
  repository: ApiPendingPhotoVerificationRepository;
}

const PendingPhotoVerificationDIContext = createContext<
  PendingPhotoVerificationDIContextType | undefined
>(undefined);

export const PendingPhotoVerificationDIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const httpClient = useHttpClientIntegration();
  const repository = new ApiPendingPhotoVerificationRepository(httpClient);
  const pendingPhotoVerificationUseCase = new FetchPendingPhotoVerificationUseCase(repository);

  const value = {
    pendingPhotoVerificationUseCase,
    repository,
  };

  return (
    <PendingPhotoVerificationDIContext.Provider value={value}>
      {children}
    </PendingPhotoVerificationDIContext.Provider>
  );
};

export const usePendingPhotoVerificationDIContext = () => {
  const context = useContext(PendingPhotoVerificationDIContext);
  if (!context) {
    throw new Error(
      'usePendingPhotoVerificationDIContext must be used within PendingPhotoVerificationDIProvider'
    );
  }
  return context;
};
